import { call } from '@/utils/yambda';
import React from 'react';

import Button from '../ImageButton/PageTitleImageButton';
import { IPageTitleProps, TPageTitleLeftProps } from '../PageTitle';
import styles from './PageTitleLeftButton.module.scss';

interface IPageTitleLeftButtonProps {
  color: IPageTitleProps['color'];
  left: IPageTitleProps['left'];
  onClickLeft: IPageTitleProps['onClickLeft'];
  onBeforeClickLeft: IPageTitleProps['onBeforeClickLeft'];
  renderLeft: IPageTitleProps['renderLeft'];
}

const PageTitleLeftButton: React.FC<IPageTitleLeftButtonProps> = ({
  color,
  left,
  onClickLeft,
  onBeforeClickLeft,
  renderLeft,
}) => {
  if (!left && !renderLeft) {
    return null;
  }

  if (renderLeft) {
    return renderLeft();
  }

  const clickBack = (typeof left !== 'string' && left?.back) || onClickLeft;
  const backButton = <Button onClick={clickBack} onBeforeClick={onBeforeClickLeft?.back} type="icon_arrowback" />;

  const clickClose = (typeof left !== 'string' && left?.close) || onClickLeft;
  const closeButton = <Button onClick={clickClose} onBeforeClick={onBeforeClickLeft?.close} type="icon_close" />;

  const renderButton = (type?: TPageTitleLeftProps): JSX.Element | null => {
    switch (type) {
      case 'back':
        return backButton;
      case 'close':
        return closeButton;
      default:
        return null;
    }
  };

  const leftButton = call(() => {
    if (typeof left === 'string') {
      return renderButton(left);
    }

    return left && Object.keys(left).map((key: TPageTitleLeftProps) => renderButton(key));
  });

  return <div className={color === 'white' ? styles.white : undefined}>{leftButton}</div>;
};

export default PageTitleLeftButton;
